module.exports = __webpack_public_path__ + "img/thumbnail_CommonWarthog_m_albino.78d53f65.png";